import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CButtonGroup>. Simpler than Bootstrap's
// version — no joined/collapsed borders between buttons, just a flex row
// with a small gap. Good enough for every current use (a handful of
// `outline` filter buttons); revisit if a call site needs the segmented-
// control look instead.
const ButtonGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="group"
    className={cn('tw-inline-flex tw-flex-wrap tw-gap-2', className)}
    {...props}
  />
))
ButtonGroup.displayName = 'ButtonGroup'

export default ButtonGroup
